export default {
  state: {
    available_colors: ['#0957cf', '#ff0000', '#00ff00']
  },
  mutations: {},
  actions: {}
}
